import { render, staticRenderFns } from "./UserDocuments.vue?vue&type=template&id=28d330c5&scoped=true"
import script from "./UserDocuments.vue?vue&type=script&lang=js"
export * from "./UserDocuments.vue?vue&type=script&lang=js"
import style0 from "./UserDocuments.vue?vue&type=style&index=0&id=28d330c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d330c5",
  null
  
)

export default component.exports